import { render, staticRenderFns } from "./ContractPaymentMethodsBankTransferDetails.vue?vue&type=template&id=8b8ba882&scoped=true&"
import script from "./ContractPaymentMethodsBankTransferDetails.vue?vue&type=script&lang=js&"
export * from "./ContractPaymentMethodsBankTransferDetails.vue?vue&type=script&lang=js&"
import style0 from "./ContractPaymentMethodsBankTransferDetails.vue?vue&type=style&index=0&id=8b8ba882&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8ba882",
  null
  
)

export default component.exports